import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-cotainer" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "title-container" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "body-container" }
const _hoisted_7 = { class: "footer-container" }

import { reactive, toRefs, onMounted, onBeforeMount, watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isShow: { // 是否显示弹窗
        type: Boolean,
        default: false,
    },
    title: { // 弹窗标题
        type: String,
        default: '',
    },
    isFooter:{
        type: Boolean,
        default: true, 
        required: false,
    },
    isShowCloseIcon:{
        type: Boolean,
        default: true, 
        required: false,
    },
},
  emits: ["onClose"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
function handleClose(){
    emit('onClose')
}

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(props.title), 1),
          _withDirectives(_createVNode(_component_vkm_svg, {
            "icon-name": "close_icon",
            class: "icon",
            onClick: handleClose
          }, null, 512), [
            [_vShow, props.isShowCloseIcon]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer")
        ], 512), [
          [_vShow, __props.isFooter]
        ])
      ])
    ])
  ]))
}
}

})